module.exports = __webpack_public_path__ + "static/media/investor3.e12e816c.svg";